import { Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TenantMembershipRole } from '@tangible/shared';

export type RoleOption = {
  label: string;
  value: TenantMembershipRole;
};

@Component({
  selector: 'app-invite-member-dialog',
  imports: [
    ButtonModule,
    DialogModule,
    FormsModule,
    InputTextModule,
    SelectModule,
  ],
  templateUrl: './invite-member-dialog.component.html',
})
export class InviteMemberDialogComponent {
  visible = model(false);
  roleOptions = input.required<RoleOption[]>();
  invite = output<{ email: string; role: TenantMembershipRole }>();

  email = '';
  role: TenantMembershipRole = 'creator';

  get canInvite(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim());
  }

  reset(): void {
    this.email = '';
    this.role = 'creator';
  }

  close(): void {
    this.visible.set(false);
  }

  submit(): void {
    if (!this.canInvite) {
      return;
    }
    this.invite.emit({ email: this.email.trim(), role: this.role });
  }
}
